import { SelectEnum } from "@edgetier/select";
import { FunctionComponent, memo } from "react";
import { InteractionType } from "@edgetier/watchtower-types";
import { IProps } from "./select-interaction-type.types";

/**
 * Interaction type select input.
 * @param props.name        Optional field name.
 * @param props.customFieldItems Allow these custom items if they are passed
 * @param props.otherProps  Props to pass to select component.
 * @returns          Select component.
 */
const SelectInteractionType: FunctionComponent<IProps> = ({
    name = "interactionType",
    customFieldItems,
    ...otherProps
}) => {
    const customItems = Object.entries(InteractionType).reduce((items, [key, interactionType]) => {
        return customFieldItems?.includes(interactionType) ? { ...items, [key]: interactionType } : { ...items };
    }, {});

    return (
        <SelectEnum
            {...otherProps}
            description="interaction type"
            name={name}
            items={typeof customFieldItems === "undefined" ? InteractionType : customItems}
        />
    );
};

export default memo(SelectInteractionType);
